import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { OndemandPrebuildoutConfirmDialogComponent } from "../ondemand-prebuildout-confirm-dialog/ondemand-prebuildout-confirm-dialog.component";
import { Product } from "../ondemand/model";
import { RegionNamesModalComponent } from "./region-names-modal/region-names-modal.component";

@Injectable({
  providedIn: "root",
})
export class ModalService {
  constructor(private ngbModal: NgbModal) {}

  onDemandPrebuildoutConfirmModal(regions: string[], products: Product[]) {
    const ngbModalRef = this.ngbModal.open(OndemandPrebuildoutConfirmDialogComponent, {
      backdrop: "static",
      size: "lg",
    });
    const component = ngbModalRef.componentInstance as OndemandPrebuildoutConfirmDialogComponent;
    component.regions = regions;
    component.products = products;
    return ngbModalRef.result;
  }

  RegionNamesModal(regionNames: string[]) {
    const ngbModalRef = this.ngbModal.open(RegionNamesModalComponent);
    const component = ngbModalRef.componentInstance as RegionNamesModalComponent;
    component.regionNames = regionNames;
    return ngbModalRef.result;
  }
}
